import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../view/Modules/Dashboard/Dashboard";
import NewUser from "../view/Modules/Users/NewUser";
import Roles from "../view/Modules/Roles/Roles";
import Users from "../view/Modules/Users/Users";
import UsersTab from "../view/Modules/Users/UsersTab";
import OrdersTab from "../view/Modules/Orders/OrdersTab";
import Countries from "../view/Modules/Countries/Countries";
import ViewUpdateProfile from "../view/Modules/Users/UpdateProfile";
import { ContentRoutes } from "./NavConstant";
import Companies from "../view/Modules/Companies/Companies";
import Company from "../view/Modules/Companies/Company";
import Customers from "../view/Modules/Customers/Customers";
import Customer from "../view/Modules/Customers/Customer";
import Cities from "../view/Modules/Cities/Cities";
import Buildings from "../view/Modules/Buildings/Buildings";
import AreasImport from "../view/Modules/AreasImport/AreasImport";

import Products from "../view/Modules/Products/Products";
import ImportProductsForCompany from "../view/Modules/Products/ImportProductsForCompany";
import CompanyProducts from "../view/Modules/Products/CompanyProducts";
import ImportProductsForStore from "../view/Modules/Products/ImportProductsForStore";
import StoreProducts from "../view/Modules/Products/StoreProducts";
import { Page401 } from "../view/pages/Page401/Page401";
import ProductStepOne from "../view/Modules/Products/ProductStepOne";
import Stores from "../view/Modules/Stores/Stores";
import Store from "../view/Modules/Stores/Store";
import OrderStepOne from "../view/Modules/Orders/OrderStepOne";
import Areas from "../view/Modules/Areas/Areas";
import BuildingsImport from "../view/Modules/BuildingsImport/BuildingsImport";
import FollowupsForCustomer from "../view/Modules/Followups/FollowupsForCustomer";
import Campaigns from "../view/Modules/Customers/Campaigns";
import CampaignCustomer from "../view/Modules/Customers/CampaignCustomer";
import CustomerImport from "../view/Modules/Customers/CustomerImport";
import Contracts from "../view/Modules/CompanyContracts/Contracts";
import Contract from "../view/Modules/CompanyContracts/Contract";
import UpdateOrderRating from "../view/Modules/Orders/UpdateOrderRating";

export default function Content() {
  return (
    <Routes>
      <Route path={ContentRoutes.USERS} element={<UsersTab />} />
      <Route path={ContentRoutes.UPDATE_USER} element={<NewUser />} />
      <Route path={ContentRoutes.CREATE_USER} element={<NewUser />} />
      <Route
        path={ContentRoutes.IMPORT_CUSTOMERS}
        element={<CustomerImport />}
      />
      <Route path={ContentRoutes.CAMPAIGNS} element={<Campaigns />} />
      <Route
        path={ContentRoutes.CREATE_CAMPAIGN_CUSTOMER}
        element={<CampaignCustomer />}
      />
      <Route path={ContentRoutes.CREATE_CUSTOMER} element={<Customer />} />
      <Route path={ContentRoutes.CUSTOMERS} element={<Customers />} />
      <Route path={ContentRoutes.UPDATE_CUSTOMER} element={<Customer />} />

      <Route path={ContentRoutes.CREATE_CONTRACT} element={<Contract />} />
      <Route path={ContentRoutes.CONTRACTS} element={<Contracts />} />
      <Route path={ContentRoutes.UPDATE_CONTRACT} element={<Contract />} />

      <Route
        path={ContentRoutes.FOLLOWUPS}
        element={<FollowupsForCustomer />}
      />
      <Route path={ContentRoutes.ORDERS} element={<OrdersTab />} />
      <Route path={ContentRoutes.CREATE_ORDER} element={<OrderStepOne />} />
      <Route path={ContentRoutes.UPDATE_ORDER} element={<OrderStepOne />} />
      <Route
        path={ContentRoutes.UPDATE_ORDER_RATING}
        element={<UpdateOrderRating />}
      />
      <Route path={ContentRoutes.CREATE_STORE} element={<Store />} />
      <Route path={ContentRoutes.DASHBOARD} element={<Dashboard />} />
      <Route path={ContentRoutes.ROLES} element={<Roles />} />
      <Route path={ContentRoutes.COUNTRIES} element={<Countries />} />
      <Route path={ContentRoutes.CITIES} element={<Cities />} />
      <Route path={ContentRoutes.AREAS} element={<Areas />} />
      <Route path={ContentRoutes.IMPORT_AREAS} element={<AreasImport />} />
      <Route path={ContentRoutes.BUILDINGS} element={<Buildings />} />
      <Route
        path={ContentRoutes.IMPORT_BUILDINGS}
        element={<BuildingsImport />}
      />
      <Route path={ContentRoutes.COMPANIES} element={<Companies />} />
      <Route path={ContentRoutes.CREATE_COMPANY} element={<Company />} />
      <Route path={ContentRoutes.UPDATE_COMPANY} element={<Company />} />
      <Route path={ContentRoutes.STORES} element={<Stores />} />
      <Route path={ContentRoutes.CREATE_STORE} element={<Store />} />
      <Route path={ContentRoutes.UPDATE_STORE} element={<Store />} />
      <Route
        path={ContentRoutes.VIEW_UPDATE_PROFILE}
        element={<ViewUpdateProfile />}
      />
      <Route path={ContentRoutes.PRODUCTS} element={<Products />} />
      <Route path={ContentRoutes.UPDATE_PRODUCT} element={<ProductStepOne />} />
      <Route path={ContentRoutes.CREATE_PRODUCT} element={<ProductStepOne />} />
      <Route path={ContentRoutes.USERS_TAB} element={<UsersTab />} />
      <Route
        path={ContentRoutes.IMPORT_PRODUCTS_FOR_COMPANY}
        element={<ImportProductsForCompany />}
      />
      <Route
        path={ContentRoutes.COMPANY_PRODUCTS}
        element={<CompanyProducts />}
      />
      <Route
        path={ContentRoutes.IMPORT_PRODUCTS_FOR_STORE}
        element={<ImportProductsForStore />}
      />
      <Route path={ContentRoutes.STORE_PRODUCTS} element={<StoreProducts />} />
      <Route path={ContentRoutes.PAGE_401} element={<Page401 />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
